import { useRouter } from "next/router";

export const usePathWithoutQuery = () => {
    const router = useRouter();
    const pathWithoutQuery = router.asPath.split('?').at(0);

  return pathWithoutQuery;
};
